module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-panel', {
    attrs: {
      "contextual-style": "primary"
    }
  }, [_c('h1', {
    staticClass: "panel-title",
    slot: "heading"
  }, [_vm._v("\n      " + _vm._s(_vm.addedit) + " User\n    ")]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.doNothing()
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": "",
      "type": "button",
      "aria-label": "Help"
    }
  }, [_vm._v("Name")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formdata.name),
      expression: "formdata.name"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.doingSomething || _vm.formdata.user_id,
      "autofocus": "",
      "aria-label": "User's  name",
      "placeholder": "Full Name (eg: Bob Smith)"
    },
    domProps: {
      "value": (_vm.formdata.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formdata.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": "",
      "type": "button",
      "aria-label": "Help"
    }
  }, [_vm._v("E-Mail")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formdata.email),
      expression: "formdata.email"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.doingSomething || _vm.formdata.user_id,
      "autofocus": "",
      "aria-label": "Email",
      "placeholder": "E-Mail address (eg: me@here.com)"
    },
    domProps: {
      "value": (_vm.formdata.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formdata.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": "",
      "type": "button",
      "aria-label": "Help"
    }
  }, [_vm._v("Roles")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formdata.roles_lists),
      expression: "formdata.roles_lists"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": ""
    },
    domProps: {
      "checked": _vm.formdata.roles_lists,
      "checked": Array.isArray(_vm.formdata.roles_lists) ? _vm._i(_vm.formdata.roles_lists, "") > -1 : (_vm.formdata.roles_lists)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.formdata.roles_lists,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formdata.roles_lists = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.formdata.roles_lists = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formdata.roles_lists = $$c
        }
      }
    }
  }), _vm._v("\n                      Manage Lists\n                    ")]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formdata.roles_profiles),
      expression: "formdata.roles_profiles"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": ""
    },
    domProps: {
      "checked": _vm.formdata.roles_profiles,
      "checked": Array.isArray(_vm.formdata.roles_profiles) ? _vm._i(_vm.formdata.roles_profiles, "") > -1 : (_vm.formdata.roles_profiles)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.formdata.roles_profiles,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formdata.roles_profiles = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.formdata.roles_profiles = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formdata.roles_profiles = $$c
        }
      }
    }
  }), _vm._v("\n                      Manage Profiles\n                    ")]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formdata.roles_admin),
      expression: "formdata.roles_admin"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": ""
    },
    domProps: {
      "checked": _vm.formdata.roles_admin,
      "checked": Array.isArray(_vm.formdata.roles_admin) ? _vm._i(_vm.formdata.roles_admin, "") > -1 : (_vm.formdata.roles_admin)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.formdata.roles_admin,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formdata.roles_admin = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.formdata.roles_admin = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formdata.roles_admin = $$c
        }
      }
    }
  }), _vm._v("\n                      User Administration\n                    ")]), _c('br')])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.doingSomething,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v(_vm._s(_vm.saveAdd))]), _vm._v("    \n                    "), _c('span', [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "disabled": _vm.doingSomething,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.deleteuser()
      }
    }
  }, [_vm._v("Delete")]), _vm._v("    \n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fail",
    attrs: {
      "disabled": _vm.doingSomething,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("Cancel")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "error",
    staticStyle: {
      "color": "#ff3333"
    }
  }, [_c('br'), _vm._v(_vm._s(_vm.errmsg))]), _c('br')])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-572d731e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/admin/user-edit/index.vue
// module id = 225
// module chunks = 1